import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  link: {
    margin: theme.spacing(1, 1.5),
  },
  toolbar: {
    flexWrap: "wrap",
  },
  toolbarTitle: {
    flexGrow: 1,
    textAlign: "left",
    textTransform: "uppercase",
    letterSpacing: -1,
  },
}));

export default function Header() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        color="default"
        elevation={0}
        className={classes.appBar}
      >
        <Toolbar className={classes.toolbar}>
          <Typography
            variant="h6"
            color="inherit"
            noWrap
            className={classes.toolbarTitle}
          >
            Thai Noodle Restaurant
          </Typography>
          <nav style={{margin: 5}}>
          
            <Link
              variant="button"
              color="textPrimary"
              href="#home"
              className={classes.link}
            >
              Home
            </Link>
            <Link
              variant="button"
              color="textPrimary"
              href="#about"
              className={classes.link}
            >
              About
            </Link>
            <Link
              variant="button"
              color="textPrimary"
              href="#location"
              className={classes.link}
            >
              Location
            </Link>
            <Link
              variant="button"
              color="textPrimary"
              href="/ThaiNoodle_Menu2024.pdf"
              className={classes.link}
            >
              Menu
            </Link>
            <Link
              variant="button"
              color="textPrimary"
              href="tel:8176840702"
              className={classes.link}
            >
              817-684-0702
            </Link>
            <Link
              variant="button"
              href="https://www.doordash.com/business/56021/?utm_source=partner-link&utm_medium=website&utm_campaign=56021&utm_content=red-m"
              target="_blank"
              alt="Order Food Delivery with DoorDash"
              title="Order Food Delivery with DoorDash"
              className={classes.link}
              style={{ textDecoration: "none" }}
            >
              <div
                style={{
                  position: "relative",
                  width: 120,
                  height: 30,
                  margin: "0px auto",
                  backgroundImage:
                    "url(https://cdn.doordash.com/media/button/button_red_m.svg)",
                  color: "transparent",
                  backgroundSize: '100% 100%',
                  display: 'inline-flex'
                }}
              >
                Order Food Delivery with DoorDash
              </div>
            </Link>
          </nav>
        </Toolbar>
      </AppBar>
    </div>
  );
}
